<template>
<div class="h-100">
    <div class="box-page">
        <div class="page-header">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">รายการบัญชีลูกค้า</span>
                <div id="wgCalendar" class="wgCalendar-normal ml-2" data-initLabelText="ทั้งหมด"></div>
                <a v-if="this.stage == 1" class="ml-2 btn btn-small btn-primary" href="#" @click="changeStage(0)">Back</a>
                <a v-if="this.stage == 1" class="ml-2 btn btn-small btn-primary" href="#" @click="exportExcel()">Print Excel</a>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-search2">
                        <i class="fa fa-search"></i>
                        <input type="text" name="search" placeholder="ค้นหาชื่อ" v-model="keyword" @keypress.enter="loadList()" class="ele-search2-input">
                    </div>
                </div>
            </div>
        </div>

        <div class="page-content" key="tran0" v-if="this.stage == 0">
            <div class="movement-filter-box ml-2 mb-3" style="border-radius: 10px; padding:10px; border:1px solid #ccc">
                <div class="row">
                    <div class="col-md-6 col-lg-6 mb-3">
                        <MemberSuggestiveSearchBox @selected="lenderChosen" />
                    </div>
                    <div class="col-md-6 col-lg-6 mb-3">
                        <MemberSuggestiveSearchBox @selected="borrowerChosen" />
                    </div>
                </div>
                
            </div>
            <div class="movement-filter-box ml-2" style="border-radius: 10px; padding:10px; border:1px solid #ccc">
                <div class="row">
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="isAll ? 'is-active' : ''"
                            @click="selectValueType('all')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>รายการทั้งหมด</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('deposit') ? 'is-active' : ''"
                            @click="selectValueType('deposit')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ฝาก</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('withdraw') ? 'is-active' : ''"
                            @click="selectValueType('withdraw')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ถอน</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('withdraw') ? 'is-active' : ''"
                            @click="selectValueType('withdraw')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ยกเลิกการถอน</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('withdraw_fee') ? 'is-active' : ''"
                            @click="selectValueType('withdraw_fee')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ค่าธรรมเนียมถอน</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('withdraw_fee') ? 'is-active' : ''"
                            @click="selectValueType('withdraw_fee')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ยกเลิกค่าธรรมเนียมถอน</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('contract_fee') ? 'is-active' : ''"
                            @click="selectValueType('contract_fee')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ค่าสร้างสัญญา</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('lender_fee') ? 'is-active' : ''"
                            @click="selectValueType('lender_fee')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ค่าธรรมเนียมผู้ให้กู้</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('view_credit_bureaus_fee') ? 'is-active' : ''"
                            @click="selectValueType('view_credit_bureaus_fee')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ค่าดูเครดิต</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('interest') ? 'is-active' : ''"
                            @click="selectValueType('interest')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>ดอกเบี้ย</div>
                        </div>
                    </div>
                    <div class="col-md-4 col-lg-4 mb-3">
                        <div class="ele-checkmark d-flex" :class="typeArray.includes('lend') ? 'is-active' : ''"
                            @click="selectValueType('lend')">
                            <div class="ele-checkmark-checkbox">
                                <i class="fa fa-check"></i>
                            </div>
                            <div>เงินสัญญา</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <a class="btn btn-small btn-primary" href="#" @click="changeStage(1)">Submit</a>
                </div>
            </div>
        </div>

        <div class="page-content" key="tran1" v-else>
            <div class="row">
                <div class="col-md-6 col-lg-4 box-info-bar px-2">
                    <div class="info-bar accent-all" style="cursor: initial;">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="info-bar-text info-bar-desc text-left">
                                <span class="text-nowrap text-color-dark">ยอดรวม</span>
                            </div>
                            <div class="info-bar-text info-bar-value" v-text="sumAmount"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2">
                    <div class="info-bar accent-contract" style="cursor: initial;">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="info-bar-text info-bar-desc text-left">
                                <span class="text-nowrap text-color-dark">ยอดเงินกู้</span>
                            </div>
                            <div class="info-bar-text info-bar-value" v-text="sumContractMoneyAmount"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2">
                    <div class="info-bar accent-contract" style="cursor: initial;">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="info-bar-text info-bar-desc text-left">
                                <span class="text-nowrap text-color-dark">ยอดซื้อขาย</span>
                            </div>
                            <div class="info-bar-text info-bar-value" v-text="sumContractThingAmount"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2">
                    <div class="info-bar accent-contract" style="cursor: initial;">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="info-bar-text info-bar-desc text-left">
                                <span class="text-nowrap text-color-dark">ยอดสัญญาสินเชื่อบ้าน</span>
                            </div>
                            <div class="info-bar-text info-bar-value" v-text="sumContractMortgageAmount"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('all')">
                    <div class="info-bar" :class="getClassInfoBar('all')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">รายการทั้งหมด</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countList"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('deposit')">
                    <div class="info-bar" :class="getClassInfoBar('deposit')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ฝาก</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countDeposit"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('withdraw')">
                    <div class="info-bar" :class="getClassInfoBar('withdraw')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ถอน</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countWithdraw"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('withdraw')">
                    <div class="info-bar" :class="getClassInfoBar('withdraw')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ยกเลิกการถอน</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countCancelWithdraw"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('withdraw_fee')">
                    <div class="info-bar" :class="getClassInfoBar('withdraw_fee')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ค่าธรรมเนียมถอน</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countWithdrawFee"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('withdraw_fee')">
                    <div class="info-bar" :class="getClassInfoBar('withdraw_fee')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ยกเลิกค่าธรรมเนียมถอน</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countCancelWithdrawFee"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('contract_fee')">
                    <div class="info-bar" :class="getClassInfoBar('contract_fee')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ค่าสร้างสัญญา</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countContractFee"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('lender_fee')">
                    <div class="info-bar" :class="getClassInfoBar('lender_fee')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ค่าธรรมเนียมผู้ให้กู้</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countLenderFee"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('view_credit_bureaus_fee')">
                    <div class="info-bar" :class="getClassInfoBar('view_credit_bureaus_fee')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ค่าดูเครดิต</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countViewCreditFee"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('interest')">
                    <div class="info-bar" :class="getClassInfoBar('interest')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">ดอกเบี้ย</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countInterest"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 box-info-bar px-2" @click="filterMovement('lend')">
                    <div class="info-bar" :class="getClassInfoBar('lend')">
                        <div class="row no-gutters">
                            <div class="col-md-6 my-auto">
                                <div class="info-bar-text info-bar-desc text-left">
                                    <span class="text-nowrap text-color-dark">เงินสัญญา</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="info-bar-text info-bar-value" v-text="countContract"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100" style="overflow-x: auto;">
                <table id="tb_datalist" class="table table-hover">
                    <thead>
                        <tr>
                            <th style="width: 100px; min-width: 100px;">
                            </th>
                            <th style="width: 70px; min-width: 70px;">
                                <div class="text-btn header-text text-center">
                                    <span>ลำดับ</span>
                                </div>
                            </th>
                            <th style="width: 110px; min-width: 110px;">
                                <div class="text-btn header-text text-center">
                                    <span>วัน/เวลา</span>
                                </div>
                            </th>
                            <th style="width: 110px; min-width: 110px;">
                                <div class="text-btn header-text text-center">
                                    <span>เลขเอกสาร</span>
                                </div>
                            </th>
                            <th style="width: 90px; min-width: 90px;">
                                <div class="text-btn header-text text-center">
                                    <span>ส่วนระบบ</span>
                                </div>
                            </th>
                            <th style="width: 130px; min-width: 130px;">
                                <div class="text-btn header-text text-right">
                                    <span>ยอดเงิน</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text">
                                    <span>ต้นทาง</span>
                                </div>
                            </th>
                            <th>
                                <div class="text-btn header-text text-left">
                                    <span>ปลายทาง</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in listMovement" :key="idx">
                            <td class="align-middle">
                                <div class="show-on-hover d-none">
                                    <div class="btn-group">
                                        <a href="#" class="btn btn-table" @click="showDetail(item.id, item, $event)" :disabled="item.disabled">รายละเอียด</a>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-text="getRowNo(idx + 1)"></span>
                            </td>
                            <td class="text-center">
                                <span v-text="item.created_at_text"></span>
                            </td>
                            <td>
                                <span v-text="item.doc_no"></span>
                            </td>
                            <td class="text-center">
                                <span class="tag-staff" :class="getCssType(item.type)" v-text="item.type_text"></span>
                            </td>
                            <td class="text-right">
                                <span v-text="item.value"></span>
                            </td>
                            <td>
                                <span v-text="item.src_name"></span>
                            </td>
                            <td>
                                <span v-text="item.dst_name"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <PaginationComponent :lastPage="lastPage" :currentPage="currentPage" ref="pagination"
                @prevPage="prevPage_Click()" @nextPage="nextPage_Click()" @changePage="changePage_Click($event)"></PaginationComponent>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import PaginationComponent from './../../sub_components/PaginationComponent';
    import MemberSuggestiveSearchBox from './../../sub_components/MemberSuggestiveSearchBox';
    import Loading from 'vue-loading-overlay';
    Vue.use(Loading);
    export default {
        components: {
            PaginationComponent,
            MemberSuggestiveSearchBox,
            Loading
        },
        data: function () {
            return {
                stage: 0,
                isAll: false,
                typeArray: [],
                lenderId: null,
                lenderName: null,
                borrowerId: null,
                borrowerName: null,

                loader: null,
                listMovement: [],
                keyword: '',
                startDate: null,
                endDate: null,
                type: null,
                totalPage: 1,
                totalItems: 0,
                lastPage: 1,
                pageSize: 50,
                currentPage: 1,
                countList: 0,
                countDeposit: 0,
                countWithdraw: 0,
                countWithdrawFee: 0,
                countCancelWithdraw: 0,
                countCancelWithdrawFee: 0,
                countContractFee: 0,
                countLenderFee: 0,
                countViewCreditFee: 0,
                countInterest: 0,
                countContract: 0,
                sumAmount: '0.00',
                sumContractMoneyAmount: '0.00',
                sumContractThingAmount: '0.00',
                sumContractMortgageAmount: '0.00',
            }
        },
        mounted() {
            this.buildJquery();
            this.selectValueType('all');
        },
        async created() {
            // this.loadList();
            // setInterval(() => {
            //     this.loadList(false);
            // }, 10000);
        },
        computed: {
        },
        methods: {
            lenderChosen: function(member) {
                this.lenderId = member.id;
                this.lenderName = member.name;
            },
            borrowerChosen: function(member) {
                this.borrowerId = member.id;
                this.borrowerName = member.name;
            },
            changeStage(newStage = 1) {
                if(newStage == 1 && (this.typeArray.length == 0 || this.lenderId === null || this.borrowerId === null)) {
                    alertbox("คุณต้องเลือกฟิลเตอร์และลูกค้าที่ต้องการกรองทั้งคู่");
                    return false;
                }

                this.stage = newStage;
                if(newStage == 0) {
                    // Do Nothing Now.
                } else if(newStage == 1) {
                    this.loadList();
                    setInterval(() => {
                        this.loadList(false);
                    }, 10000);
                }
            },
            selectValueType(newType) {
                if(newType == 'all') {
                    if(this.isAll == true) {
                        this.isAll = false;
                        this.typeArray = [];
                    } else {
                        this.isAll = true;
                        this.typeArray = ['deposit',
                            'withdraw',
                            'withdraw_fee',
                            'contract_fee',
                            'lender_fee',
                            'view_credit_bureaus_fee',
                            'interest',
                            'lend'
                        ];
                    }
                } else {
                    let index = this.typeArray.indexOf(newType);
                    index === -1 ? this.typeArray.push(newType) : this.typeArray.splice(index, 1);

                    if(this.typeArray.length != 8) {
                        this.isAll = false;
                    }
                }
                
            },
            prevPage_Click() {
                this.currentPage -= 1;
                this.loadList();
            },
            nextPage_Click() {
                this.currentPage += 1;
                this.loadList();
            },
            changePage_Click(pageNo) {
                this.currentPage = pageNo;
                this.loadList();
            },
            showLoading() {
                this.loader = this.$loading.show({
                  canCancel: false,
                });
            },
            hideLoading() {
                if (this.loader != null) {
                  this.loader.hide();
                }
            },
            buildJquery() {
                const vm = this;
                $('#wgCalendar').wgCalendar({
                    startDate: new Date(),
                    submitDate: function(data, self) {
                        if (data.isAllDate) {
                            vm.startDate = null;
                            vm.endDate = null;
                        } else {
                            vm.startDate = moment(data.startDate).format('YYYY-MM-DD');
                            vm.endDate = moment(data.endDate).format('YYYY-MM-DD');
                        }

                        if(vm.stage == 1) {
                            vm.loadList();
                        }
                    }
                });
            },
            loadList(isShowLoading = true) {
                if (isShowLoading) {
                    this.showLoading();
                }
                let params = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    
                    keyword: this.keyword,
                    pageSize: this.pageSize,
                    currentPage: this.currentPage,
                    typeArray: this.typeArray,

                    lenderId: this.lenderId,
                    borrowerId: this.borrowerId
                };
                return axios.post(`${this.baseUrl}/admin/movement/api/customer-list`, params).then(({ data }) => {
                    if (data != null) {
                        this.countList = data.total;
                        this.countDeposit = data.countDeposit;
                        this.countWithdraw = data.countWithdraw;
                        this.countWithdrawFee = data.countWithdrawFee;
                        this.countCancelWithdraw = data.countCancelWithdraw;
                        this.countCancelWithdrawFee = data.countCancelWithdrawFee;
                        this.countContractFee = data.countContractFee;
                        this.countLenderFee = data.countLenderFee;
                        this.countViewCreditFee = data.countViewCreditFee;
                        this.countInterest = data.countInterestRate;
                        this.countContract = data.countAmountContract;
                        this.listMovement = data.data;
                        this.totalItems = data.total;
                        this.lastPage = data.totalPage;
                        this.sumAmount = data.sumAmount;
                        this.sumContractMoneyAmount = data.sumContractMoneyAmount;
                        this.sumContractThingAmount = data.sumContractThingAmount;
                        this.sumContractMortgageAmount = data.sumContractMortgageAmount;
                    } else {
                        this.countList = 0;
                        this.countDeposit = 0;
                        this.countWithdraw = 0;
                        this.countWithdrawFee = 0;
                        this.countCancelWithdraw = 0;
                        this.countCancelWithdrawFee = 0;
                        this.countContractFee = 0;
                        this.countLenderFee = 0;
                        this.countViewCreditFee = 0;
                        this.countInterest = 0;
                        this.countContract = 0;
                        this.listMovement = [];
                        this.totalItems = 0;
                        this.lastPage = 1;
                        this.sumAmount = 0;
                        this.sumContractMoneyAmount = 0;
                        this.sumContractThingAmount = 0;
                        this.sumContractMortgageAmount = 0;
                    }

                    this.$nextTick(() => {
                        this.$refs.pagination.bindListPageNo();
                    });
                }).catch(err => {
                    console.log('err', err);
                })
                .then(() => {
                    setTimeout(() => {
                        this.hideLoading();
                    }, 500);
                });
            },
            choosePage(currentPage) {
                this.currentPage = currentPage;
                this.loadList();
            },
            getRowNo(index) {
                return ((this.currentPage - 1) * this.pageSize) + index;
            },
            getCssType(type) {
                if (type == 'deposit') {
                    return 'tag-deposit';
                } else if (type == 'withdraw') {
                    return 'tag-withdraw';
                } else if (type == 'contract_fee') {
                    return 'tag-contract-fee';
                } else if (['withdraw_fee', 'lender_fee', 'view_credit_bureaus_fee'].includes(type)) {
                    return 'tag-fee';
                } else if (type == 'interest') {
                    return 'tag-interest';
                } else if (type == 'lend' || type == 'borrow') {
                    return 'tag-contract';
                }
                return '';
            },
            filterMovement(type = null) {
                this.selectValueType(type);
                this.loadList();
            },
            getClassInfoBar(type) {
                if(type == 'all' && this.isAll) {
                    return 'accent-all';
                } else if(type == 'all' && !this.isAll) {
                    return '';
                }

                if (this.typeArray.includes(type)) {
                    if (type == 'deposit') {
                        return 'accent-deposit';
                    } else if (type == 'withdraw') {
                        return 'accent-withdraw';
                    } else if (type == 'contract_fee') {
                        return 'accent-contract-fee';
                    } else if (type == 'withdraw_fee') {
                        return 'accent-fee';
                    } else if (type == 'lender_fee') {
                        return 'accent-fee';
                    } else if (type == 'view_credit_bureaus_fee') {
                        return 'accent-fee';
                    } else if (type == 'interest') {
                        return 'accent-interest';
                    } else if (type == 'lend') {
                        return 'accent-contract';
                    }
                } 
                return '';
            },
            exportExcel() {
                if (this.listMovement != null && this.listMovement && this.listMovement.length > 0) {
                    var report = XLSX.utils.json_to_sheet(this.listMovement);
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, report, 'Movement template');
                    const time = moment().format('YYYY-MM-DD_HH:mm:ss');
                    XLSX.writeFile(wb, `excel_listcustomer_movement_${time}.xlsx`);
                } else {
                    alertbox('ไม่มีข้อมูล');
                }
            },
        },
        props: {
            baseUrl: ''
        },
    }
</script>

<style lang="scss" scoped>
    $color-all: #8618EA;
    $color-deposit: #01df01;
    $color-withdraw: #00bfff;
    $color-contract-fee: #ff9919;
    $color-fee: #ac58fa;
    $color-interest: #fa58ac;
    $color-contract: #d0d462;
    .accent-all {
        border-left-color: $color-all;
    }
    .accent-deposit {
        border-left-color: $color-deposit;
    }
    .accent-withdraw {
        border-left-color: $color-withdraw;
    }
    .accent-contract-fee {
        border-left-color: $color-contract-fee;
    }
    .accent-fee {
        border-left-color: $color-fee;
    }
    .accent-interest {
        border-left-color: $color-interest;
    }
    .accent-contract {
        border-left-color: $color-contract;
    }

    .tag-staff {
        display: inline-block;
        line-height: 20px;
        min-width: 120px;
        &.tag-deposit {
            background-color: $color-deposit;
        }
        &.tag-withdraw {
            background-color: $color-withdraw;
        }
        &.tag-contract-fee {
            background-color: $color-contract-fee;
        }
        &.tag-fee {
            background-color: $color-fee;
        }
        &.tag-interest {
            background-color: $color-interest;
        }
        &.tag-contract {
            background-color: $color-contract;
        }
    }
</style>



